export class ColorUtils {
  private static readonly STEP = 30;
  private static readonly BINS = Math.floor(360 / this.STEP);
  private static readonly SL_COMBOS = [
    {s: 72, l: 60},
    {s: 62, l: 68},
    {s: 78, l: 56},
    {s: 58, l: 74},
  ];

  static getColor(value: string, alpha: number): string {
    const hval = this.hash32(value);

    const idx = hval % this.BINS;
    const base = idx * this.STEP;

    const JITTERS = [-12, -8, -4, 0, 4, 8, 12];
    const jitter = JITTERS[(hval >>> 8) % JITTERS.length];

    const hue = (base + jitter + 360) % 360;

    const combo = this.SL_COMBOS[(hval >>> 16) & 3];

    const s = this.clamp(combo.s + (((hval >>> 20) % 5) - 2), 52, 82);
    const l = this.clamp(combo.l + (((hval >>> 23) % 5) - 2), 52, 78);

    return `hsla(${hue}, ${s}%, ${l}%, ${alpha})`;
  }

  private static clamp(v: number, lo: number, hi: number) {
    return Math.min(hi, Math.max(lo, v));
  }

  private static hash32(str: string): number {
    let h = 0x811c9dc5;
    for (let i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return (h >>> 0);
  }

  static hslToNormalizedRgb(h: number, s: number, l: number): [number, number, number] {
    s /= 100;
    l /= 100;

    const c = (1 - Math.abs(2 * l - 1)) * s;
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
    const m = l - c / 2;

    let r = 0, g = 0, b = 0;

    if (h >= 0 && h < 60) {
      r = c;
      g = x;
      b = 0;
    } else if (h >= 60 && h < 120) {
      r = x;
      g = c;
      b = 0;
    } else if (h >= 120 && h < 180) {
      r = 0;
      g = c;
      b = x;
    } else if (h >= 180 && h < 240) {
      r = 0;
      g = x;
      b = c;
    } else if (h >= 240 && h < 300) {
      r = x;
      g = 0;
      b = c;
    } else if (h >= 300 && h < 360) {
      r = c;
      g = 0;
      b = x;
    }

    r = r + m;
    g = g + m;
    b = b + m;
    return [r, g, b];
  }
}
